module.exports = __webpack_public_path__ + "assets/img/big.7c31c080.png";